import { useState, useEffect } from 'react'

// Reads delayed home-exchange quotes from /api/foreign-quotes (Yahoo-backed,
// local + USD, DB fallback cache). Only the Global Desk "Home Market" tab uses
// it, so it's fetched lazily — pass `enabled=false` until that tab is shown so
// we don't fire the 77-symbol Yahoo batch on every Global Desk open.
//
// Returns { quotes, loading } where quotes[ticker] =
//   { local, ccy, usd, stale, fetched_at? }.
export function useForeignQuotes(enabled = true) {
  const [quotes, setQuotes] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    setLoading(true)
    fetch('/api/foreign-quotes')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) { setQuotes(d?.quotes ?? {}); setLoading(false) } })
      .catch(() => { if (!cancelled) { setLoading(false) } })
    return () => { cancelled = true }
  }, [enabled])

  return { quotes, loading }
}
